import cn from "classnames";
import { Transition } from "components/shared/column";
import Select from "components/shared/select";
import { paths } from "helpers/paths";
import { REPORT_TYPES } from "helpers/reports";
import React, { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { applyReportAllowedUsers, getAllUsersForSelectList, getReportAllowedUsers } from "sources/admin";
import container from "./container";

function AdminReportAllowedUsers(props: { history: any; modal: (params: {}) => void }) {
    const [loading, setLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState<number>();
    const [data, setData] = useState<{ displayName: string; id: number }[]>();

    const getItems = () => {
        setLoading(true);
        getReportAllowedUsers(REPORT_TYPES.ClientStatisticsReport).then((res) => {
            setData(res);
            setLoading(false);
        });
    };
    useEffect(() => {
        getItems();
    }, []);

    const removeUser = (id: number) => {
        props.modal({
            name: "confirm",
            title: "Действительно удалить пользователя?",
            buttons: { confirm: "Да", cancel: "Нет" },
            action: () =>
                applyReportAllowedUsers({
                    reportId: REPORT_TYPES.ClientStatisticsReport,
                    userIds: data?.reduce((acc, item) => (id === item.id ? acc : [...acc, item.id]), []) ?? [],
                }).then(getItems),
        });
    };

    const addUser = () => {
        if (!selectedUserId) {
            return;
        }
        setLoading(true);
        applyReportAllowedUsers({
            reportId: REPORT_TYPES.ClientStatisticsReport,
            userIds: [...(data?.map((item) => item.id) ?? []), selectedUserId],
        }).then(getItems);
    };

    const selectProps = {
        inputProps: { name: "selectedUserId" },
        url: getAllUsersForSelectList,
        value: selectedUserId,
        onChange: ({ value }: { value: number }) => setSelectedUserId(value),
        propName: "fullNameOrEmail",
    };

    return (
        <div className="page-content">
            <Transition dir="full">
                <div className="page-book__list book-list list book-list--nofilter">
                    <div className="book-list__head-wrap">
                        <div className="book-list__head">
                            <div
                                className="book-list__head-close close close--sm"
                                onClick={() => props.history.push(paths.root)}
                            />
                            <div className="book-list__head-title">
                                Доступ к отчету &quot;Отчет по динамике показателей клиентов&quot;
                            </div>
                        </div>
                    </div>
                    <div className={cn("list__body-wrap d-flex flex-column", { loading })}>
                        <div className="container mb-4">
                            <div className="d-flex">
                                <div className="w-50">
                                    <Select {...selectProps} />
                                </div>
                                <div
                                    className={cn("btn btn-brand btn-sm ml-4", { disabled: !selectedUserId })}
                                    onClick={addUser}
                                >
                                    Добавить пользователя
                                </div>
                            </div>
                        </div>
                        <div className="flex-1">
                            <Scrollbars>
                                <div className="h-100 container-fluid table-responsive">
                                    <table className="table table-sm">
                                        <thead className="thead-light sticky-header">
                                            <tr>
                                                <th>#</th>
                                                <th>Пользователь</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((item, i) => (
                                                <tr key={item.id}>
                                                    <td>{i + 1}</td>
                                                    <td>{item.displayName}</td>
                                                    <td>
                                                        <div
                                                            className="btn btn-xs btn-outline-danger"
                                                            onClick={() => removeUser(item.id)}
                                                        >
                                                            Удалить
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    );
}

export default container(AdminReportAllowedUsers);
